import { type CSSProperties, useMemo } from "react";
import Shift from "./Shift";
import UnavailableEvent from "../../../../../components/UnavailableEvent";
import OpenShift from "./OpenShift";

interface EventDisplayProps {
    event: any;
    style?: CSSProperties;
    className?: string;
}

function EventDisplay({ event, style, className }: EventDisplayProps) {
    const content = useMemo(() => {
        if (event?.type === "unavailable") {
            return (
                <UnavailableEvent
                    event={event}
                    style={style}
                    variant="rose"
                />
            );
        } else if (event?.type === "open-shifts") {
            return (
                <OpenShift
                    event={event}
                    style={style}
                />
            )
        } else {
            return (
                <Shift
                    event={event}
                    style={style}
                    className={className}
                />

            );
        }
    }, [event, style, className]);

    return content;
};

export default EventDisplay;
